import React from 'react';
import { Camera } from 'lucide-react';
import { imageData, getAltText, getTitle } from '../../data/images';

const GallerySection = ({ language, currentContent }) => {
  const { galleryImages, featuredImage } = imageData;

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-dancing">
            {currentContent.gallery.title}
          </h2>
          <p className="text-xl text-tilcara-orange font-medium mb-4">
            {currentContent.gallery.subtitle}
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {currentContent.gallery.humanSubtitle}
          </p>
        </div>

        {/* Gallery by Categories */}
        <div className="space-y-16">
          {galleryImages.map((category, categoryIndex) => (
            <div key={categoryIndex} className="">
              {/* Category Title */}
              <h3 className="text-2xl font-semibold text-gray-900 mb-8 text-center capitalize">
                {currentContent.gallery.categories[category.category]}
              </h3>
              
              {/* Images Grid */}
              <div className={`grid gap-6 ${
                category.images.length === 1 ? 'grid-cols-1 max-w-md mx-auto' :
                category.images.length === 2 ? 'grid-cols-1 md:grid-cols-2 max-w-4xl mx-auto' :
                category.images.length === 3 ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' :
                'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
              }`}>
                {category.images.map((image, imageIndex) => (
                  <div key={imageIndex} className="gallery-item bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                    <div className="aspect-w-16 aspect-h-12 overflow-hidden">
                      <img
                        src={image.src}
                        alt={getAltText(image, language)}
                        className="w-full h-64 object-cover transition-transform duration-300 hover:scale-110"
                      />
                    </div>
                    <div className="p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">
                        {getTitle(image, language)}
                      </h4>
                      <div className="flex items-center space-x-2 text-gray-600">
                        <Camera className="h-4 w-4" />
                        <span className="text-sm">{getAltText(image, language)}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Featured Image Section */}
        <div className="mt-16 text-center">
          <div className="max-w-4xl mx-auto">
            <img
              src={featuredImage.src}
              alt={getAltText(featuredImage, language)}
              className="w-full rounded-2xl shadow-2xl"
            />
            <p className="mt-6 text-lg text-gray-600 font-dancing">
              {currentContent.gallery.finalMessage}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
